import * as API from './request';
const comUrl = "/v1/admin/";
const DigitalAsset = {
  getOverview(params) {
    return API.get(`${comUrl}statistics`, params);
  }
}
export default DigitalAsset;